import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios'

import * as G from '../../theme/global-styles';
import * as S from './styles';

import ClientLogo from '../../components/ClientLogo';
import { ThemedButton } from '../../components/ThemedButton';
import PoweredByQITech from '../../components/PoweredByQITech';
import { useThemeContext } from "../../contexts/ThemeContext";
import { getOrCreateBrowserKey } from '../../utils/fingerprint_utils'
import { ErrorPage } from "../ErrorPage"
import { LoadingPage } from '../LoadingPage'

export const ConfiaPage = (props) => {
    const { clientThemeSettings } = useThemeContext();
    const { signData, setSignerStep, setSignData, folderMode } = props;
    const isFolderMode = !!folderMode;
    const [loadingStatus, setLoadingStatus] = useState(false);
    const [loading, setLoading] = useState(false)
    const initialError = { "has_error": false, "status": 0 }
    const [error, setError] = useState({})

    const handleNextStep = useCallback(async () => {
        let browserKey = null;
        try {
            browserKey = await getOrCreateBrowserKey();
        } catch (err) {
        }
        const payload = {
            "step": "face_recognition",
            "event_date": new Date().toISOString(),
            "image_key": "generated_by_confia",
            "device_data": {
                "device_key": browserKey
            }
        }

        const config = {
            headers:
            {
                'Authorization': signData.signer_token
            }
        }

        setLoading(true)

        axios.patch('/signer', payload, config)
            .then(response => {
                setSignerStep(response.data.next_step)
                setSignData({ ...signData, ...response.data })
            })
            .catch((error) => {
                if ([401, 403, 409].includes(error.response?.status)) {
                    setError({
                        "has_error": true,
                        "status": error.response.status
                    })
                } else {
                    setError({
                        "has_error": true,
                        "status": 500
                    })
                }
            })
            .finally(() => {
                setLoading(false)
            })
    }, [signData, setSignData, setSignerStep])

    const verifyDocumentStatus = useCallback(async () => {
        const config = {
            headers:
            {
                'Authorization': signData.signer_token
            }
        }

        axios.get('/signer/confia_status_url', config)
            .then(response => {
                if (response.data.status === 'signed')
                    handleNextStep()

                if (['blocked', 'deleted', 'refused'].includes(response.data.status))
                    setSignerStep('deactivated')
            })
    }, [signData.signer_token, handleNextStep, setSignerStep])

    useEffect(() => {
        if (isFolderMode) {
            let active = true;
            const tick = () => {
                folderMode.pollAndAdvance().then((status) => {
                    if (active && status) {
                        setError({ "has_error": true, "status": status });
                    }
                });
            };
            tick();
            const interval = setInterval(tick, 3000);
            return () => { active = false; clearInterval(interval); };
        }

        verifyDocumentStatus();

        const interval = setInterval(verifyDocumentStatus, 3000);

        return () => clearInterval(interval);
    }, [isFolderMode, folderMode, verifyDocumentStatus]);

    const handleStartSignature = () => {
        setLoadingStatus(true);

        const currentUrl = window.location.href;
        const confiaUrl = isFolderMode ? folderMode.confiaSignUrl : signData?.confia_sign_url

        const finalUrl = `${confiaUrl}&urlCallback=${encodeURIComponent(currentUrl)}`;

        window.open(finalUrl, '_blank');

        setTimeout(() => setLoadingStatus(false), 2000);
    };

    if (loading) {
        return (
            <LoadingPage clientThemeSettings={clientThemeSettings} />
        )
    }


    return (
        <G.Container style={{ padding: "16px 0" }}>
            <ClientLogo clientThemeSettings={clientThemeSettings} size="small" />
            <S.TermContainer>
                <G.Title>Dupla Jornada em site de Parceiro</G.Title>
                <S.Divider />
                <S.Subtitle>Redirecionamento para o site da Confia</S.Subtitle>
                <p>
                    Para continuar o processo de assinatura, é necessário completar a jornada no nosso provedor parceiro.
                    Ao clicar no botão você será <b>direcionado para o site da Confia</b> e deve finalizar a sua assinatura no site deles.
                </p>
                <S.Subtitle>Retorno para o QI Sign</S.Subtitle>
                <p>
                    Depois de finalizar a jornada no site da Confia, você será redirecionado <b>de volta para o QI Sign automaticamente.</b> 
                    Basta aguardar alguns segundos para a tela ser atualizada.
                </p>
            </S.TermContainer>
            {error.has_error &&
                <ErrorPage
                    error={error}
                    redirectToLogin={() => setSignerStep("login")}
                    resetError={() => setError(initialError)}
                    clientThemeSettings={clientThemeSettings}
                />
            }
            <S.Footer>
                <ThemedButton
                    clientThemeSettings={clientThemeSettings}
                    $loading={loadingStatus}
                    onClick={handleStartSignature}
                >
                    {loadingStatus ? 'Carregando..' : 'Realizar validação biométrica'}
                </ThemedButton>
                <PoweredByQITech />
            </S.Footer>
        </G.Container>
    );
}